import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import { PortalHeader } from "@/components/auth/CredentialAuth";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const portal = params.get("portal") || "member";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const loginPath = portal === "admin" ? "/admin-login" : portal === "coach" ? "/coach-login" : "/login";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) return setError("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated. You can sign in now.");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-white" data-testid="reset-password-page">
      <PortalHeader current={portal} />
      <main className="flex items-center justify-center px-5 py-16">
        <form onSubmit={submit} data-testid="reset-password-form" className="w-full max-w-md border border-zinc-800 bg-zinc-950 p-8 sm:p-10">
          <p className="text-[10px] uppercase tracking-[0.25em] text-volt font-bold">Secure password link</p>
          <h1 className="font-display uppercase text-5xl leading-none mt-3">Choose a new password</h1>
          {!token && <p className="mt-5 text-sm text-red-400">This link is missing its security token.</p>}
          {done ? (
            <Link data-testid="reset-login-link" to={loginPath}
              className="mt-8 block bg-volt text-black text-center uppercase tracking-[0.18em] text-xs font-extrabold py-4 hover:bg-white transition-colors">
              Continue to sign in
            </Link>
          ) : (
            <>
              <input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required minLength={10} placeholder="New password"
                className="mt-8 w-full bg-ink border border-zinc-700 px-4 py-4 text-sm focus:border-volt outline-none" />
              <input data-testid="reset-password-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                required minLength={10} placeholder="Confirm new password"
                className="mt-4 w-full bg-ink border border-zinc-700 px-4 py-4 text-sm focus:border-volt outline-none" />
              {error && <p data-testid="reset-password-error" className="mt-4 text-sm text-red-400">{error}</p>}
              <button data-testid="reset-password-submit" disabled={busy || !token}
                className="mt-7 w-full bg-volt text-black uppercase tracking-[0.18em] text-xs font-extrabold py-4 hover:bg-white disabled:opacity-50 transition-colors">
                {busy ? "Updating…" : "Update password"}
              </button>
            </>
          )}
        </form>
      </main>
    </div>
  );
}
